import { createSlice } from '@reduxjs/toolkit';

export const appsPageInitialState = {
  appId: '',
  appReportOption: '',
};

// Then, handle actions in your reducers:
const appsPageSlice = createSlice({
  name: 'appsPage',
  appsPageInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    appsPageSetSelectedAppState: (state, { payload }) => {
      state.appId = payload;
    },
    appsPageSetSelectedReportOptionState: (state, { payload }) => {
      state.appReportOption = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { appsPageSetSelectedAppState, appsPageSetSelectedReportOptionState } = appsPageSlice.actions;

// The reducer
export const appsPageReducer = appsPageSlice.reducer;
